export const setCurrentRoute = (route) => {
        return (dispatch) => {
            dispatch({
                type: "SET_CURRENT_ROUTE",
                payload: route,
            })
        }
    };
export const clearError500 = () => {
    return (dispatch) => {
        dispatch({
            type: "CLEAR_ERROR_500",
            payload: false,
        })
    }
};

